import { apiSlice } from "@/shared/api/api-slice"

export const emojiApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getEmojiSprite: builder.query<string, string>({
      queryFn: async (emojiId, _api, _extra, baseQuery) => {
        const result = await baseQuery({
          url: `/api/v1/emoji/${emojiId}/file`,
          responseHandler: response => response.blob()
        })

        if (result.error) return { error: result.error }

        if (!(result.data instanceof Blob)) {
          return { error: { status: "CUSTOM_ERROR", error: "Expected Blob response" } }
        }

        const objectUrl = URL.createObjectURL(result.data)
        return { data: objectUrl }
      },
      async onCacheEntryAdded(_emojiId, { cacheDataLoaded, cacheEntryRemoved }) {
        try {
          const { data: objectUrl } = await cacheDataLoaded
          await cacheEntryRemoved
          URL.revokeObjectURL(objectUrl)
        } catch {
          // Cache entry was removed or the query failed before data loaded
        }
      }
    })
  })
})

export const { useGetEmojiSpriteQuery, useLazyGetEmojiSpriteQuery } = emojiApi
